import React, { useState } from "react";

import { Menu, MenuItem, ListItemText } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { SUPPORTED_LANGUAGES, getLang, changeLanguage } from "../../translate/locale";

/**
 * Item do menu do usuário (Perfil / Idioma / Sair) que abre um submenu com os
 * idiomas suportados. A troca grava em localStorage (i18nextLng) e recarrega a
 * página, porque os textos são lidos com i18n.t() na renderização.
 */
const LanguageMenu = ({ onSelected }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const current = getLang();

  const handleSelect = async lang => {
    setAnchorEl(null);
    if (onSelected) onSelected();
    if (lang !== current) await changeLanguage(lang);
  };

  return (
    <>
      <MenuItem onClick={e => setAnchorEl(e.currentTarget)}>
        <ListItemText
          primary={i18n.t("mainDrawer.appBar.user.language")}
          secondary={i18n.t(`languages.${current}`)}
        />
      </MenuItem>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {SUPPORTED_LANGUAGES.map(lang => (
          <MenuItem key={lang} selected={lang === current} onClick={() => handleSelect(lang)}>
            {i18n.t(`languages.${lang}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageMenu;
